import React, { Component} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import Loader from "@amzn/meridian/loader";
import Link from "@amzn/meridian/link";
import {getPackageHistoryData} from "../../../commons/api/GetPackageHistoryResults.js";
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Icon from "@amzn/meridian/icon";
import Toaster from "@amzn/meridian/toaster"
import Alert from "@amzn/meridian/alert"
import { validateEmail, oldTimeZoneMapper, destinationTypeMapper, handleBlankValue, convertLocaleTimeToFormat, handlePackageReasonMapping } from "../../../commons/CommonUtils.js";
import { FormattedMessage, injectIntl } from "react-intl";
import {PackageStatesTranslationKeyMap} from "../../../commons/dataStore/TranslationsMapping";
import {getStringForUseCase} from "../../../util/CommonUtils";
import metricsPublisher from "../../../metrics";
import {
    MEDIA_CATEGORY_DEFAULT_METRIC_VALUE, MEDIA_CATEGORY_METRIC_NAME,
    SECURE_LENS_METHOD_METRIC_NAME,
    TRACKING_ID_METRIC_NAME
} from "../../../commons/constants/MetricConstants";
import {ITEM_STATUS} from "../../../commons/constants/CommonConstants";

class PackageHistory extends Component {

    constructor(props) {
        super(props)
        this.state = {
          isLoading : true,
          previousPageTokens: [null],
          nextPageToken: null,
          toasters: []
        }
        this.setUpdated = props.setUpdated.bind(this)
    }

    getPageSize() {
        return 100;
    }

    searchPath = "#" + this.props.previousPath + "/";

    searchAssociateRequestOption = (eventTime) => {
        let currentEpochMillis = eventTime ? eventTime : new Date().getTime();
        let localCurrentEpochMillis = currentEpochMillis - (new Date().getTimezoneOffset() * 60 * 1000);
        let currentDate = new Date(localCurrentEpochMillis).toISOString().substr(0, 10);
        return {
            "type": "ASSOCIATE",
            "startDate": new Date(currentDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000),
            "endDate": new Date(currentDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000) + (60 * 60 * 24 * 1000)
        }
    }

    fetchAssociate = (lastProcessedByAssociateName, eventTime) => {
        return lastProcessedByAssociateName ?
        (validateEmail(lastProcessedByAssociateName) ? 
        (<Link href = {this.searchPath.concat(lastProcessedByAssociateName).concat("/" + JSON.stringify(this.searchAssociateRequestOption(eventTime)))}>{lastProcessedByAssociateName}</Link>)
        : lastProcessedByAssociateName
        )
        : '';
    }

    async nextButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });

        if (!this.state.nextPageToken) {
            this.setState({
                isLoading: false,
                toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
            });
        } else {

            let packageHistoryData = await getPackageHistoryData(this.props.packageId,
                 this.getPageSize(), this.state.nextPageToken);
            this.setUpdated({})

            if (packageHistoryData.packageHistory.length > 0) {
                this.setState({
                    isLoading: false,
                    previousPageTokens: this.state.previousPageTokens.concat([this.state.nextPageToken]),
                    packageHistory : packageHistoryData.packageHistory,
                    nextPageToken : packageHistoryData.nextPageToken
                });

            } else {
                this.setState({
                    isLoading: false,
                    toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
                });
            }
        }
    }

    async previousButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });
  
        let newPreviousPageTokens = this.state.previousPageTokens.slice(0, -1);
        let prevPageToken = newPreviousPageTokens.slice(-1).pop();

        let packageHistoryData = await getPackageHistoryData(this.props.packageId,
            this.getPageSize(), prevPageToken);
        this.setUpdated({})

       if (packageHistoryData.packageHistory.length > 0) {
           this.setState({
               isLoading: false,
               previousPageTokens: newPreviousPageTokens,
               packageHistory : packageHistoryData.packageHistory,
               nextPageToken : packageHistoryData.nextPageToken
           });

       } else {
           this.setState({
               isLoading: false,
               toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_previous_entry'}), timeout: 3000}]
           });
       }
    }

    async componentDidMount() {
        let packageHistoryData = await getPackageHistoryData(this.props.packageId, this.getPageSize());
        this.setUpdated({})
        this.setState({
            isLoading : false,
            packageHistory : packageHistoryData.packageHistory ? packageHistoryData.packageHistory : [],
            nextPageToken : packageHistoryData.nextPageToken
        })
    }

    sentenceCase (str) {
        if ((str===null) || (str===''))
             return null;
        else
         str = str.toString();
        return str.toLowerCase().replace(/_/g," ").replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }

     async publishMediaClickMetrics(trackingId, mediaCategory) {
         const mediaClickMetricsPublisher = (await metricsPublisher).newChildActionPublisherForMethod(SECURE_LENS_METHOD_METRIC_NAME);
         let mediaCategoryValue = mediaCategory ? mediaCategory : MEDIA_CATEGORY_DEFAULT_METRIC_VALUE;
         mediaClickMetricsPublisher.publishString(TRACKING_ID_METRIC_NAME, trackingId);
         mediaClickMetricsPublisher.publishString(MEDIA_CATEGORY_METRIC_NAME, mediaCategoryValue);
     }

    fetchOtherAttributes (history) {
        let driverName = history.driverName;
        let movedToContainer = history.scanContainer;
        let routeCode = history.routeCode;
        let scheduledDeliveryStart = history.scheduledDeliveryStart;
        let scheduledDeliveryEnd = history.scheduledDeliveryEnd;
        let destinationDeliveryStation = history.destinationDeliveryStation;
        let deliveryLatitude = history.deliveryLatitude;
        let deliveryLongitude = history.deliveryLongitude;
        let recipientDoorNumber = history.recipientDoorNumber;
        let recipientName =  history.recipientName;
        let storeName = history.storeName;
        let manifestRouteCode = history.manifestRouteCode;
        let transportRequestState = history.transportRequestState;
        let imageUrl = history.imageUrl;
        let mediaDataList = history.mediaDataList;
        let useCase = history.useCase;
        let trackingId = history.trackingId;
        let scannableItemsStatus = history.scannableItemsStatus;
        let result = [];
        if (driverName) {
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_driverName" defaultMessage="Driver Name"/>:</Text><Text>{driverName}</Text></React.Fragment>);
        }
        if (imageUrl) {
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_productImageUrl" defaultMessage="Product Image "/>:</Text><a href={imageUrl} target="_blank" rel="noopener noreferrer">Link</a></React.Fragment>);
        }

        if (mediaDataList && mediaDataList.length > 0) {
            mediaDataList.forEach((mediaData, index) => {
                if (mediaData.mediaURL && mediaData.mediaType === 'IMAGE') {
                    const mediaLabel = `${mediaData.category ? mediaData.category + ' ' : ''}Image - ${index + 1}`;
                    result.push(
                        <React.Fragment key={index}>
                            <a href={mediaData.mediaURL} target="_blank" rel="noopener noreferrer"
                               onClick={() => {this.publishMediaClickMetrics(trackingId, mediaData.category)}}>
                                {mediaLabel}
                            </a>
                            {index < mediaDataList.length - 1 && ','}
                        </React.Fragment>
                    );
                }
            });
        }

        if (scannableItemsStatus) {
            Object.entries(scannableItemsStatus).forEach(([key, value]) => {
                if (result.length) {
                    result.push(<Text type="h100">,</Text>);
                }
                result.push(<React.Fragment><Text type="h100"><FormattedMessage id={`search.package.history_${key.toLowerCase()}`} defaultMessage={ITEM_STATUS[key]}/>:</Text><Text>{value}</Text></React.Fragment>);
            });
        }

        if (transportRequestState) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_transportRequestState" defaultMessage="Transport Request Status"/>:</Text><Text>{transportRequestState}</Text></React.Fragment>);
        }
        if (movedToContainer) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_movedToContainer" defaultMessage="Moved to Container"/>:</Text><Text>{movedToContainer}</Text></React.Fragment>);
        }
        if (routeCode) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_route" defaultMessage="Route"/>:</Text><Text>{routeCode}</Text></React.Fragment>);
        }
        if (scheduledDeliveryStart || scheduledDeliveryEnd) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            scheduledDeliveryStart = scheduledDeliveryStart ? new Date(scheduledDeliveryStart).toLocaleString('en-US', {timeZone: oldTimeZoneMapper(this.props.stationTimeZone)}) : "-";
            scheduledDeliveryEnd = scheduledDeliveryEnd ? new Date(scheduledDeliveryEnd).toLocaleString('en-US', {timeZone: oldTimeZoneMapper(this.props.stationTimeZone)}) : "-";
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_scheduledDeliveryWindow" defaultMessage="Scheduled Delivery Window"/>:</Text><Text>{scheduledDeliveryStart}</Text><Text><FormattedMessage id="search.package.history_to" defaultMessage="to"/></Text><Text>{scheduledDeliveryEnd}</Text></React.Fragment>);
        }
        if (destinationDeliveryStation) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_destinationDeliveryStation" defaultMessage="Destination Delivery Station"/>:</Text><Text>{destinationDeliveryStation}</Text></React.Fragment>);
        }
        if (deliveryLatitude) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_latitude" defaultMessage="Latitude"/>:</Text><Text>{deliveryLatitude}</Text></React.Fragment>);
        }
        if (deliveryLongitude) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_longitude" defaultMessage="Longitude"/>:</Text><Text>{deliveryLongitude}</Text></React.Fragment>);
        }
        if (recipientDoorNumber) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_recipientDoorNumber" defaultMessage="Recipient Door Number"/>:</Text><Text>{recipientDoorNumber}</Text></React.Fragment>);
        }
        if (recipientName) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_recipientName" defaultMessage="Recipient Name"/>:</Text><Text>{recipientName}</Text></React.Fragment>);
        }
        if (storeName) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_storeName" defaultMessage="Store Name"/>:</Text><Text>{storeName}</Text></React.Fragment>);
        }
        if (manifestRouteCode) {
            if (result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment><Text type="h100"><FormattedMessage id="search.package.history_manifestRouteCode" defaultMessage="Manifest Route Code"/>:</Text><Text>{manifestRouteCode}</Text></React.Fragment>);
        }
        if(useCase) {
            if(result.length) {
                result.push(<Text type="h100">,</Text>);
            }
            result.push(<React.Fragment>
                            <Text type="h100"><FormattedMessage id="search.package.history_useCase" defaultMessage="Usecase"/>:</Text>
                            <Text><FormattedMessage id={getStringForUseCase(useCase)} defaultMessage={useCase}/></Text>
                        </React.Fragment>);
        }
        return <Row spacing="small">{handleBlankValue(result)}</Row>;
    }

    render() {
        return this.state.isLoading ? <Row spacingInset="large" widths={["grid-2"]}><Column/><Loader/></Row> : this.renderHistoryTable();
    }

    // Todo: Reuse for other cells
    renderTableCell(cell) {
        return (
            <TableCell alignmentVertical="top">
                <div style={{"whiteSpace": "nowrap"}}>
                    {cell}
                </div>
            </TableCell>
        )
    }

    renderPackageStateTableCell(packageState) {
        const translationId = PackageStatesTranslationKeyMap[packageState]
        const defaultMessage = handleBlankValue(this.sentenceCase(packageState))
        return translationId
            ? this.renderTableCell(<FormattedMessage id={translationId} defaultMessage={defaultMessage}/>)
            : this.renderTableCell(defaultMessage)
    }

    renderHistoryTable() {
        return (
            <React.Fragment>
                <Toaster toasts={this.state.toasters} onCloseToast={() => {this.setState({toasters: []})}} alignmentHorizontal="center">
                    {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                </Toaster>
                <Column spacingInline="large large none large">
                    <Row widths={["grid-12"]} spacingInset="none">
                        <div style={{"overflowX": "scroll"}}>
                            <Table showDividers={false} spacing="small">
                            <TableRow>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_date" defaultMessage="Date"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_source" defaultMessage="Source"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_status" defaultMessage="Current Status"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_operation" defaultMessage="Operation"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_destination" defaultMessage="Destination"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_reason" defaultMessage="Reason"/></Text></TableCell>
                                <TableCell width={160}><Text type="h100"><FormattedMessage id="search.package.history_eventProcessedBy" defaultMessage="Event Processed By"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_location" defaultMessage="Location"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_sortZone" defaultMessage="Sort Zone"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.package.history_cycle" defaultMessage="Cycle"/></Text></TableCell>
                                <TableCell width={160}><Text type="h100"><FormattedMessage id="search.package.history_otherAttributes" defaultMessage="Other Attributes"/></Text></TableCell>
                            </TableRow>
                            { this.state.packageHistory && this.state.packageHistory.map(history => {
                                let stateTime = new Date(history.stateTime).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    timeZone: this.props.stationTimeZone? oldTimeZoneMapper(this.props.stationTimeZone): undefined});
                                let historyOperation = history.operation && history.operation.includes('PACKAGE_STATE_UPDATE') ? 'PACKAGE_SCAN' : history.operation;
                                return <TableRow>   
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{convertLocaleTimeToFormat(stateTime)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(destinationTypeMapper(history.source))}</div></TableCell>
                                {this.renderPackageStateTableCell(history.packageState)}
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(historyOperation))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(destinationTypeMapper(history.destination))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(handlePackageReasonMapping("HISTORY", "ALL", this.sentenceCase(history.reasonCode)))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchAssociate(handleBlankValue(history.scanAssociate), history.stateTime)}</div></TableCell>                              
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.scanLocation)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.sortZone)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.cycle)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchOtherAttributes(history)}</div></TableCell>
                            </TableRow>   
                            })}  
                            </Table>
                        </div>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} spacingInset="none">
                        <Button type="link" onClick={this.previousButtonClick.bind(this)} disabled={this.state.previousPageTokens.length <= 1}><Icon tokens={chevronLeftLargeTokens} /></Button>
                        <Button type="link" onClick={this.nextButtonClick.bind(this)}><Icon tokens={chevronRightLargeTokens} /></Button>
                    </Row>  
                </Column> 
            </React.Fragment>       
        )
    }
}


export default injectIntl(PackageHistory);




// WEBPACK FOOTER //
// ./src/components/detailPages/packageDetails/PackageHistory.js